import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { ProfileLogin } from '@/auth/interfaces/login-response';
import { logOutAxios } from '@/shared/actions/auth/auth.actions';
import { Nullable } from '@/shared/interfaces/nullable';
import { useUiStore } from '../ui/ui.store';
import { useUserPermissionsStore } from './user-permissions.store';
import { useMfaStatusStore } from './mfa-status.store';
import { queryClient } from '@/shared/query-client/query-client';

type UserLoginAuthType = Nullable<ProfileLogin>;

interface AuthStore {
  ///* state
  token: string;
  user: UserLoginAuthType;
  isAuth: boolean;
  isLoading: boolean;
  //departamento:string;

  token_drive: string;
  setTokenDrive: (token_drive: string) => void;

  ///* actions
  setAuth: (token: string, user: UserLoginAuthType) => void;
  logout: (showAlert?: boolean) => Promise<boolean>;
  setToken: (token: string) => void;
  setIsLoading: (isLoading: boolean) => void;
  //setDepartamento:(departamento:string)=>void;

  logOutWithoutToken: () => Promise<void>;
}

export const useAuthStore = create<AuthStore>()(
  persist(
    set => ({
      token: '',
      token_drive: '',

      user: null,
      isAuth: false,
      isLoading: false,

      setTokenDrive: token_drive => {
        set({ token_drive });
      },

      ///* actions
      setAuth: (token, user) => {
        // TODO: validate user data

        if (user) {
          const adicionales = user?.canales_venta_adicionales ?? [];
          const principal = user?.canal_venta ? [user.canal_venta] : [];
          const canales = [...adicionales, ...principal].filter((v) => Boolean(v));
          user.canales = canales;
        }

        set({ token, user, isAuth: !!token /* && !!user?.id */ });
      },

      setToken: token => {
        set({ token });
      },

      logout: async (showAlert = true): Promise<boolean> => {
        const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
        const setAlert = useUiStore.getState().setAlert;

        ///* logout request
        setIsGlobalLoading(true);
        const res = await logOutAxios();
        setIsGlobalLoading(false);

        showAlert && setAlert(true, res.message, res.status);
        set({ token: '', user: null, isAuth: false });
        localStorage.clear();
        useUserPermissionsStore.getState().clear();
        useMfaStatusStore.getState().clear();

        if (res.code == 200) return true;

        return false
      },

      logOutWithoutToken: async () => {
        set({ token: '', user: null, isAuth: false });
        localStorage.clear();
        useUserPermissionsStore.getState().clear();
        useMfaStatusStore.getState().clear();
        queryClient.clear();
      },

      setIsLoading: isLoading => {
        set({ isLoading });
      },

      /* setDepartamento:departamento=>{
        set({departamento})
      }, */
    }),

    // localStorage
    {
      name: 'auth',
    }
  )
);
